import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { TimeoutService } from '@df/ng/timeout.service';
import { UiAccordionContentDirective } from '@df/ui/accordion/content/accordion-content.directive';
import { UiAccordionItemDirective } from '@df/ui/accordion/item/accordion-item.directive';
import { UiAccordionTriggerDirective } from '@df/ui/accordion/trigger/accordion-trigger.directive';
import { UiButtonDirective } from '@df/ui/button/button.directive';
import { MultisiteFlagComponent } from '../multisite-flag.component';
import { MultisiteSwitchComponent } from '../multisite-switch.component';

@Component({
    selector: 'multisite-switch-mobile',
    templateUrl: './multisite-switch-mobile.component.html',
    styleUrls: ['../../ui/accordion/item/accordion-item.component.scss', './multisite-switch-mobile.component.scss'],
    hostDirectives: [
        {
            directive: UiAccordionItemDirective,
            inputs: ['uiAccordionItemValue:value', 'uiAccordionItemDisabled:disabled']
        }
    ],
    standalone: true,
    imports: [MultisiteFlagComponent, UiAccordionContentDirective, UiAccordionTriggerDirective, UiButtonDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSwitchMobileComponent extends MultisiteSwitchComponent {
    readonly open = inject(UiAccordionItemDirective, { self: true }).open;

    /**
     * Class constructor with deps
     */
    constructor(_ref: ChangeDetectorRef, timeoutService: TimeoutService) {
        super(_ref, timeoutService);

        this._ref.reattach();
    }
}
